module.exports = __webpack_public_path__ + "static/sitewise-green-06bb35775f9d435a1ff93f843640df6a.jpg";